import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { Socket } from 'ngx-socket-io';
import { AuthService } from '../login/auth.service';
import { updateDeviceInfo, updateUser } from '../redux/actions/user.actions';
import { AppState } from '../redux/app.state';
import { UpdateUserDto, User } from 'src/typings';
import { NotificationService } from '../services/notification.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface UserOrderStatus {
  done: { status: string; count: number };
  proc: { status: string; count: number };
  wh: { status: string; count: number };
  decline: { status: string; count: number };
}

const EMPTY_ORDER_STATUS: UserOrderStatus = {
  done: { count: 0, status: 'Завершен' },
  proc: { count: 0, status: 'В обработке' },
  wh: { count: 0, status: 'Собран' },
  decline: { count: 0, status: 'Отказ' }
};

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  user: User | undefined;

  userUpdatedGW = this.socket.fromEvent<User>('user_updated');

  constructor(
    private store: Store<AppState>,
    private http: HttpClient,
    private authService: AuthService,
    private socket: Socket,
    private notificationService: NotificationService,
    private ngZone: NgZone,
    private deviceService: DeviceDetectorService
  ) {
    this.detectDeviceType();
    this.store.subscribe((data) => {
      this.user = data.user.info;
    });
    this.userUpdatedGW.subscribe((user) => {
      if (!user) return;
      if (user.id === this.user?.id) this.store.dispatch(updateUser({ payload: user }));
    });
  }

  detectDeviceType() {
    this.ngZone.runOutsideAngular(() => {
      this.ngZone.run(() => {
        this.store.dispatch(updateDeviceInfo({ deviceInfo: this.deviceService.getDeviceInfo() }));
      });
    });
  }

  getUser(id: number) {
    return this.http.get<User>(`${environment.BACKEND}/user/info/${id}`);
  }

  update(payload: UpdateUserDto) {
    return this.http.put<User>(`${environment.BACKEND}/user/update`, payload).subscribe((data) => {
      this.notificationService.notice(`Пользователь сохранен!`);
      this.store.dispatch(updateUser({ payload: data }));
    });
  }

  uploadFile(file: File, product_id?: number) {
    const formData: FormData = new FormData();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    formData.set('file', file), formData.set('product_id', `${product_id}`);
    return this.http.post<{ name: string }>(`${environment.BACKEND}/image/upload`, formData);
  }

  getOrderStatus() {
    return of(EMPTY_ORDER_STATUS);
  }
}
